import { AxiosInstance } from 'axios';
import { initAxios } from 'utils/axios';
import { BaseInsightPayload } from 'types/store/normalized/insights/InsightDataPayload';
import { serializeParamsWithArray } from '../utils';

class InsightDataApi {
  private readonly axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = initAxios();
  }

  async getInsightData(
    url: string,
    filters?: Record<string, unknown>
  ): Promise<BaseInsightPayload> {
    try {
      const { data } = await this.axiosInstance.get<BaseInsightPayload>(url, {
        params: filters,
        paramsSerializer: serializeParamsWithArray,
      });
      return data;
    } catch (error) {
      throw new Error(`Failed to fetch insight data from ${url}: ${error}`);
    }
  }
}

export default InsightDataApi;
